import { render, staticRenderFns } from "./TournamentDetailsTable.vue?vue&type=template&id=4a5c5ef4"
import script from "./TournamentDetailsTable.vue?vue&type=script&lang=js"
export * from "./TournamentDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetailsTable.vue?vue&type=style&index=0&id=4a5c5ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports